// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pe-c";
export var backButton = "_pe-4";
export var backIcon = "_pe-5";
export var chevronShortcut = "_pe-6";
export var container = "_pe-1";
export var editor = "_pe-8";
export var editorWrapper = "_pe-7";
export var prefix = "_pe-2";
export var searchIcon = "_pe-3";
export var suffix = "_pe-9";
export var suffixContent = "_pe-a";
export var suffixText = "_pe-b";
export var wrapper = "_pe-0";